import React, { Component } from 'react';
import './index.css';

class Row5 extends Component {
  constructor(props) {
    super(props);
    this.state = {

    }
  }


  render() {
    return (
      <div className='pdf-invoice-grid-row5'>
        <div className='pdf-invoice-grid-row5-side-header'>
          <div className='pdf-invoice-grid-row5-side-header-text'>{'نسخه مشتری'}</div>
        </div>
        <div className='pdf-invoice-grid-row5-content'>
          <div className='pdf-invoice-grid-row5-content-wrapper'>
            <div className='pdf-invoice-grid-row5-content-cl1'>
              <div><b>شرایط و نحوه‌ی فروش</b> :
                <span> نقدی <div className='pdf-invoice-grid-row5-ch-box'>
                    <img alt='' src={require('../../../../assets/images/check-mark.svg')} className='pdf-invoice-grid-row5-check-mark-icon'/>
                  </div>
                </span>
                <span> غیر نقدی <div className='pdf-invoice-grid-row5-ch-box'></div></span>
              </div>
            </div>
            <div className='pdf-invoice-grid-row5-content-cl2'>
              <div><b>مهر و امضای فروشنده</b> :</div>
              <img width='200' alt="" src={require('../../../../assets/images/stamp.png')}/>
            </div>
            <div className='pdf-invoice-grid-row5-content-cl3'>
              <div><b>مهر و امضای خریدار</b> :</div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}




export default Row5;
